// import React, { useState, useEffect } from 'react';

// const BiddingList = ({ data, onBidAccepted, isCreatingTrip }) => {
//     const [selectedItemId, setSelectedItemId] = useState(null);
//     const [processedData, setProcessedData] = useState([]);

//     useEffect(() => {
//         setProcessedData(data);
//     }, [data]);

//     const handleItemPress = (itemId) => {
//         setSelectedItemId(itemId === selectedItemId ? null : itemId);
//     };

//     const InfoItem = ({ heading, value }) => (
//         value ? (
//             <div className="flex justify-between px-4 py-1 border-b">
//                 <span className="font-semibold">{heading}:</span>
//                 <span>{value}</span>
//             </div>
//         ) : null
//     );

//     return (
//         <div className="w-full max-w-lg mx-auto p-4">
//             {processedData.map((item) => {
//                 const isSelected = item.id === selectedItemId;
//                 return (
//                     <div key={item.id} className={`border ${isSelected ? 'border-black' : 'border-gray-300'} rounded-lg mb-4 p-4`}> 
//                         <div 
//                             className="flex items-center cursor-pointer flex-wrap md:flex-nowrap"
//                             onClick={() => handleItemPress(item.id)}
//                         >
//                             <div className="mr-4 text-xl">
//                                 {isSelected ? '✅' : '⬜'}
//                             </div>
//                             {item?.cruzeId?.thumbnailImage && (
//                                 <img 
//                                     src={item.cruzeId.thumbnailImage} 
//                                     alt="Cruze" 
//                                     className="w-16 h-16 object-cover rounded-md mr-4"
//                                 />
//                             )}
//                             <div className="flex-1 min-w-0">
//                                 <h3 className="text-lg font-bold">{item?.rider?.first_name} {item?.rider?.last_name}</h3>
//                                 <p className="text-sm text-gray-600">Rated {item?.rider?.rating?.toFixed(2)}/5</p>
//                                 <p className="text-sm text-gray-500">{item?.cab_request?.distance} KM away | Arriving in {item?.cab_request?.duration} mins</p>
//                             </div>
//                             <div className="text-xl font-bold text-green-600 ml-auto md:ml-0">
//                                 ₹ {item?.pricing?.finalAmount}
//                             </div>
//                         </div>

//                         {isSelected && (
//                             <>
//                                 <div className="mt-4 bg-gray-100 p-2 rounded">
//                                     <InfoItem heading="Cruze" value={item?.rider?.vehicle_name} />
//                                     <InfoItem heading="Cruze#" value={item?.rider?.vehicle_number} />
//                                     <InfoItem heading="Seating" value={`${item?.rider?.vehicleSeatingCapacity}+1`} />
//                                     <InfoItem heading="Class" value={item?.rider?.vehicleClass} />
//                                     <InfoItem heading="Color" value={item?.rider?.vehicleColor} />
//                                 </div>
                                
//                                 <div className="flex justify-center mt-4">
//                                     {isCreatingTrip ? (
//                                         <div className="loader border-4 border-blue-500 border-t-transparent rounded-full w-6 h-6 animate-spin"></div>
//                                     ) : (
//                                         <button 
//                                             className="bg-green-500 text-white py-2 px-6 rounded hover:bg-green-700"
//                                             onClick={() => onBidAccepted(item, item.rider.id, item.rider.fcm_token, item.rider.phone_number)}
//                                         >
//                                             ACCEPT
//                                         </button>
//                                     )}
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                 );
//             })}
//         </div>
//     );
// };

// export default BiddingList;


import React, { useState, useEffect } from 'react';
import Pricing from '../profile/components/Pricing';
// import Pricing from '../bookingSummary/components/Pricing';
import { FaBolt, FaCheckSquare } from "react-icons/fa";
import noImage from '../../assets/imgs/noImage.png';

export const getBidDriverImage = (item) => item?.rider?.avatar_url?.trim() || '';

const BiddingList = ({ data, onBidAccepted, isCreatingTrip }) => {
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [processedData, setProcessedData] = useState([]);

    useEffect(() => {
        setProcessedData(data);
    }, [data]);

    const handleItemPress = (itemId) => {
        setSelectedItemId(itemId === selectedItemId ? null : itemId);
    };
// console.log("data pricing",data)
    const InfoItem = ({ heading, value }) => (
        value ? (
            <div className="flex justify-between px-2 py-1 border-b text-sm">
                <span className="font-medium">{heading}:</span>
                <span>{value}</span>
            </div>
        ) : null
    );

    return (
        <div className="w-full max-w-md mx-auto p-2">
            {processedData.map((item) => {
                const isSelected = item.id === selectedItemId;
                return (
                    <div 
                        key={item.id} 
                        className={`border ${isSelected ? 'border-black' : 'border-gray-300'} rounded-lg mb-3 p-3 shadow-sm`}
                    > 
                        <div 
                            className="flex items-center cursor-pointer flex-wrap md:flex-nowrap gap-2"
                            onClick={() => handleItemPress(item.id)}
                        >
                            <div className="text-lg">
                                {isSelected ? <FaCheckSquare/> : '⬜'}
                            </div>

                            <div className="relative shrink-0">
                                <img
                                    src={getBidDriverImage(item) || noImage}
                                    alt="Driver"
                                    className="w-12 h-12 object-cover rounded-full bg-gray-100"
                                />
                                {item?.bidMode === 'A' && (
                                    <span className="absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full bg-white text-black shadow">
                                        <FaBolt className="h-3 w-3" aria-label="Auto bid" />
                                    </span>
                                )}
                            </div>

                            <div className="flex-1 min-w-0">
                                <h3 className="text-md font-semibold">{item?.rider?.first_name} {item?.rider?.last_name}</h3>
                                <p className="text-xs text-gray-600">⭐ {item?.rider?.rating?.toFixed(2)}/5</p>
                                <p className="text-xs text-gray-500">{item?.cab_request?.distance} KM | {item?.cab_request?.duration} mins</p>
                            </div>

                            <div className="text-md font-semibold text-green-600 ml-auto md:ml-0">
                                ₹ {item?.pricing?.finalAmount}
                            </div>
                        </div>

                        {isSelected && (
                            <>
                                <div className="mt-2 bg-gray-50 p-2 rounded text-sm">
                                    <InfoItem heading="Cruze" value={item?.rider?.vehicle_name} />
                                    <InfoItem heading="Cruze#" value={item?.rider?.vehicle_number} />
                                    <InfoItem heading="Seating" value={`${item?.rider?.vehicleSeatingCapacity}+1`} />
                                    <InfoItem heading="Class" value={item?.rider?.vehicleClass} />
                                    <InfoItem heading="Color" value={item?.rider?.vehicleColor} />
                                    <Pricing  pricing={item?.pricing}/>
                                </div>
                              

                                <div className="flex justify-center mt-2">
                                    {isCreatingTrip ? (
                                        <div className="loader border-4 border-blue-500 border-t-transparent rounded-full w-5 h-5 animate-spin"></div>
                                    ) : (
                                        <button 
                                            className="bg-black text-white py-1 px-4 rounded text-sm hover:bg-green-700"
                                            onClick={() => onBidAccepted(item, item.rider.id, item.rider.fcm_token, item.rider.phone_number)}
                                        >
                                            ACCEPT
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default BiddingList;

